import { render, staticRenderFns } from "./CollegeFirst.vue?vue&type=template&id=93f078b8&scoped=true&"
import script from "./CollegeFirst.vue?vue&type=script&lang=js&"
export * from "./CollegeFirst.vue?vue&type=script&lang=js&"
import style0 from "./CollegeFirst.vue?vue&type=style&index=0&id=93f078b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f078b8",
  null
  
)

export default component.exports